// extracted by mini-css-extract-plugin
module.exports = {"fragmentWrapper":"index-module_fragmentWrapper_1ZD7u","table":"index-module_table_N8uFx"};